import axios from "axios";
import { OrderRoutes } from "./Routes";

export async function GetOrderDetailsById(id, setOrderDetails) {
  try {
    await axios.get(OrderRoutes.GetSinlgeOrder + id).then((res) => {
      if (res.status === 200) {
        setOrderDetails(res.data);
      }
    });
  } catch (err) {
    console.log(err);
  }
}
